/**
 * Serializa somente os verificadores administrativos legados de suporte.
 *
 * A coleta pós-atualização tem seu próprio coordenador; esta fila existe para
 * impedir que bootstrap/foreground disparem diagnóstico e full-state legados
 * ao mesmo tempo, preservando os caminhos manuais e automáticos existentes.
 */
let tail: Promise<void> = Promise.resolve();

export const enqueueLegacySupportCheck = (task: () => Promise<void> | void): Promise<void> => {
  const next = tail.catch(() => undefined).then(task);
  tail = next.catch(() => undefined);
  return next;
};

export const __resetLegacySupportCheckQueueForTests = (): void => {
  tail = Promise.resolve();
};
